module.exports = __webpack_public_path__ + "static/media/couple-diamond.27a26aba.svg";